import { render } from "./BaseImportUpload.vue?vue&type=template&id=22e99df8"
import script from "./BaseImportUpload.vue?vue&type=script&lang=js"
export * from "./BaseImportUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__